import React from 'react'
import {
	BlogPostsContainer,
	BlogPost,
} from '../../../common/primitives/BlogPosts/BlogPosts'
import styles from './HostingBlogPosts.scss'
import img1 from './img/blog-hosting-advantages.jpg'
import img2 from './img/blog-hosting-starting.jpg'
import img3 from './img/blog-hosting-therms.jpg'
import {__t} from '../../../common/lang/text-resource'

export default function HostingBlogPosts() {
	return (
	  <section className={styles.container}>
		  <h2>{__t('Твоят първи сайт')}</h2>
		  <BlogPostsContainer id='hosting-blog-posts' useInitialAnimation={false}>
			  <BlogPost
				analyticsPositionIndex={1}
				analyticsType={"Hosting blog posts"}
				className={styles.post}
				link='https://blog.superhosting.bg/hosting-quality.html'
				title={__t('Избираш хостинг? Тези 10 предимства ще ти помогнат!')}
				description={__t('хостингът-е-основата-на-твоя-сайт-но-кои-са-елеме19609b')}
				img={img1}
			  />
			  <BlogPost
				analyticsPositionIndex={2}
				analyticsType="Hosting blog posts"
				className={styles.post}
				link='https://blog.superhosting.bg/how-to-have-website.html'
				title={__t('Искам сайт, но не знам откъде да започна')}
				description={__t('виж-кои-са-стъпките-които-трябва-да-извървиш-за-дc413c0')}
				img={img2}
			  />
			  <BlogPost
				analyticsPositionIndex={3}
				analyticsType="Hosting blog posts"
				className={styles.post}
				link='https://blog.superhosting.bg/3-web-hosting-terms.html'
				title={__t('3+1 основни термина в уеб хостинга')}
				description={__t('не-е-нужно-да-знаеш-и-разбираш-абсолютно-всеки-ед54e246')}
				img={img3}
			  />
		  </BlogPostsContainer>
	  </section>
	)
}
